import {
  Button,
  CircularProgress,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { handleSpringDataMutationRequest } from "../../../api";
import { toast } from "material-react-toastify";
import "material-react-toastify/dist/ReactToastify.css";

function LockBookings(props) {
  console.log(props.invoiceData.invoice.room_ids_list[0]);

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const [selectedRooms, setselectedRooms] = useState([
    props.invoiceData.invoice.room_ids_list[0],
  ]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    if (value.length > 0)
      setselectedRooms(
        // On autofill we get a the stringified value.
        typeof value === "string" ? value.split(",") : value
      );
  };

  useEffect(() => {}, [selectedRooms]);
  const [loader, setloader] = useState(false);

  const save = () => {
    setloader(true);
    handleSpringDataMutationRequest(
      "POST",
      `core/api/v1/reservation/set-single-reservation-locked-status?status=LOCKED&reservationId=${props?.reservationId[selectedRooms]}`
    )
      .then((res) => (props.isGrid ? props.reloadGrid() : ""))
      .then((res) => props.updateInvoice())
      .then((res) => props.updateSummaryData())
      .then((res) => toast.success("Successfully locked room"))
      .then((res) => setloader(false))
      .catch((err) => toast.error("Something went wrong"))
      .catch((err) => console.error(err));
  };

  return (
    <div>
      <h4
        style={{ marginLeft: "2rem", marginTop: "2rem", marginBottom: "1rem" }}
      >
        Select the room id to lock room
      </h4>

      <div
        className="d-flex"
        style={{ marginLeft: "2rem", marginRight: "2rem" }}
      >
        <FormControl sx={{ width: "100%" }}>
          <InputLabel>Room ids</InputLabel>
          <Select
            value={selectedRooms}
            onChange={handleChange}
            required="true"
            MenuProps={MenuProps}
            label="Room ids"
          >
            {props?.invoiceData?.invoice?.room_ids_list?.map((name) => (
              <MenuItem key={name.id} value={name}>
                {name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      <h2>
        <span
          class="badge"
          style={{
            background: "#96C7C1",
            marginLeft: "2rem",
            marginRight: "2rem",
            marginTop: "1rem",
            width: "90%",
          }}
        >
          You are about to lock Room {selectedRooms}
        </span>
      </h2>
      <Divider />
      <Button
        className="float-right mr-4 mb-3 mt-4"
        variant="custom-button"
        onClick={save}
        disabled={loader}
      >
        {loader ? (
          <CircularProgress size={15} color="inherit" sx={{ ml: 1.5 }} />
        ) : (
          "Yes, Lock room"
        )}
      </Button>
    </div>
  );
}

export default LockBookings;
